<template lang="pug">
	div.d-flex
		.avatar.mr-3
			img.img-avatar(:src='_speaker.value.image || defaultAvatar' alt='')
		div
			| {{ _speaker.value.first_name }} {{ _speaker.value.last_name }}
			.small.text-muted
				span(v-if="_speaker.value.company || _speaker.value.organisation")
					template(v-if='_speaker.value.company || _speaker.value.organisation')
						| {{ _speaker.value.company || _speaker.value.organisation }}
						span(v-if="_speaker.value.position")  | {{ _speaker.value.position }}

</template>

<script>
	export default {
		name: 'speakerCard',
		props: ['_speaker'],
		data: () => ({
			defaultAvatar: '/img/placeholders/avatar.png',
		}),
	}
</script>
